/**
 * Turn a raw DB enum / code into operator- and user-facing text.
 *
 *   UNDER_REVIEW        → "Under review"
 *   LTC_HOME            → "LTC home"
 *   RETIREMENT_RESIDENCE→ "Retirement residence"
 *   prospect            → "Prospect"
 *
 * Sentence case (only the first word is capitalised) EXCEPT recognised acronyms,
 * which stay upper. This is the single humanizer for admin table cells, metric
 * copy, and status labels so raw SCREAMING_SNAKE never reaches a user.
 */
// Domain acronyms that must NOT be title-cased.
const ACRONYMS = new Set([
    'LTC', 'VSC', 'HST', 'RN', 'RPN', 'PSW', 'DSW', 'EFT', 'HC', 'AR', 'NACC',
    'CNO', 'TB', 'SIN', 'ID', 'PAD', 'QBO', 'TOTP', 'URL', 'PDF', 'DSW', 'GST',
    'ESA', 'PHI', 'DO', 'CAD',
]);
export function humanizeEnum(value) {
    if (!value)
        return '';
    const words = value.split(/[_\s]+/).filter(Boolean);
    return words
        .map((w, i) => {
        const upper = w.toUpperCase();
        if (ACRONYMS.has(upper))
            return upper;
        const lower = w.toLowerCase();
        return i === 0 ? lower.charAt(0).toUpperCase() + lower.slice(1) : lower;
    })
        .join(' ');
}
//# sourceMappingURL=humanize.js.map